import { Link } from '@tanstack/react-router'
import { useTranslation } from '@/shared/i18n/useTranslation'
import styles from './AccountTabs.module.css'

/** Shared tab bar across the account section: Perfil, Plano & assinatura, Preferências. */
export function AccountTabs() {
  const { t } = useTranslation()

  return (
    <nav className={styles.tabs} aria-label="Conta">
      <Link to="/profile" className={styles.tab} activeProps={{ className: styles.active }}>
        {t('nav.profile')}
      </Link>
      <Link to="/subscription" className={styles.tab} activeProps={{ className: styles.active }}>
        Plano &amp; assinatura
      </Link>
      <Link to="/preferences" className={styles.tab} activeProps={{ className: styles.active }}>
        {t('prefs.title')}
      </Link>
    </nav>
  )
}
